import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-control_option",
  "use": "icon-control_option-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-control_option\"><g transform=\"translate(2 2)\"><circle stroke=\"currentColor\" fill=\"transparent\" cx=\"6\" cy=\"6\" r=\"5.5\" /><circle cx=\"6\" cy=\"6\" r=\"3\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol